import React, { FC, useEffect, useState } from "react";
import { Link } from "../Partials/Link";
import { StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface GoBackProps {
  label: string;
}

export const GoBack: FC<GoBackProps> = (props) => {
  const { label } = props;

  const [url, setUrl] = useState("/");

  useEffect(() => {
    setUrl(document.referrer);
  }, []);

  return (
    <div className="treaterGoBack">
      <Link
        href={url}
        type="button"
        buttonType="clear"
        buttonTier="primary"
        buttonSize="medium"
      >
        <StreamLineIcon
          iconName="s-arrow-left-dash"
          className="treaterGoBack__icon"
        />
        <span>{label}</span>
      </Link>
    </div>
  );
};
